/* KR Live library presentation. Playback remains owned by YouTube native controls. */
(() => {
  if (customElements.get('hv-live-library')) return;
  class HavehadLiveLibrary extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const tabs = [...this.querySelectorAll('[data-live-tab]')];
      const panels = [...this.querySelectorAll('[data-live-panel]')];
      const activate = (tab, focus = false) => {
        tabs.forEach(node => { const active = node === tab; node.setAttribute('aria-selected', String(active)); node.tabIndex = active ? 0 : -1; });
        panels.forEach(node => { node.hidden = node.dataset.livePanel !== tab.dataset.liveTab; });
        const channel = this.querySelector('[data-live-channel]');
        if (channel) channel.href = `https://www.youtube.com/@havehad_seoul/${tab.dataset.liveTab}`;
        if (focus) tab.focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab), options);
        tab.addEventListener('keydown', event => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + tabs.length) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + tabs.length) % tabs.length;
          else return;
          event.preventDefault(); activate(tabs[next], true);
        }, options);
      });
      const cards = [...this.querySelectorAll('[data-live-video]')];
      cards.forEach(card => card.addEventListener('click', () => {
        const id = card.dataset.liveVideo;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        const hero = this.querySelector('[data-live-hero]');
        if (!hero) return;
        const frame = document.createElement('iframe');
        frame.dataset.livePlayer = '';
        frame.title = card.dataset.title;
        frame.src = `https://www.youtube.com/embed/${id}?controls=1&playsinline=1&autoplay=0&rel=0`;
        frame.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        // Removing the previous iframe tears down its browsing context and stops playback.
        hero.replaceChildren(frame);
        hero.dataset.kind = card.dataset.kind;
        const title = this.querySelector('[data-live-title]');
        if (title) title.textContent = card.dataset.title;
        const link = this.querySelector('[data-live-youtube]');
        if (link) link.href = `https://www.youtube.com/watch?v=${id}`;
        cards.forEach(node => node.setAttribute('aria-pressed', String(node === card)));
      }, options));
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('hv-live-library', HavehadLiveLibrary);
})();
